export interface NotificationItem {
    id: string; // use string to match mobile, even if backend returns number
    title: string;
    body: string;
    data?: Record<string, any>;
    timestamp: number; // unix timestamp
    isRead: boolean;
    type?: 'info' | 'success' | 'warning' | 'error';
    actionUrl?: string;
    notificationId?: string; // UUID from sender to prevent duplicates
    notificationLogId: number; // Backend notification log ID for syncing
    templateName: NotificationTemplate; // Notification template name
  }

export interface NotificationHistoryLogItem {
    "id": number;
    "template_name": string;
    "title": string;
    "body": string;
    "data": {
        "body": string;
        "title": string;
        "language": string;
        "driver_name": string;
        "location_ar": string;
        "location_en": string;
        "template_name": NotificationTemplate;
        "notification_id": string;
        "notification_log_id": string;
    },
    "sent_at": string;
    "success": boolean;
    "error_message": string;
}
  
export enum NotificationTemplate {
    PICKUP_ASSIGNED = "pickup_assigned",
    DELIVERY_ASSIGNED = "delivery_assigned",
    PAYMENT_ASSIGNED = "payment_assigned",
    SYSTEM_ALERT = "system_alert",
    CUSTOM_NOTIFICATION = "custom_notification",
    DRIVER_ASSIGNED_TO_PICKUP_YOUR_ORDERS = "driver_assigned_for_pickup",
    DRIVER_UNASSIGNED_FROM_PICKUP_YOUR_ORDERS = "driver_unassigned_from_pickup",
    DRIVER_ASSIGNED_FOR_PAYMENT = "driver_assigned_for_payment",
    DRIVER_COMPLETED_PAYMENT = "driver_completed_payment",
    DRIVER_DROPPED_ORDERS_AT_WAREHOUSE = "driver_dropped_orders_at_warehouse",
}

export interface NotificationState {
    notifications: NotificationItem[];
    unreadCount: number;
    isLoading: boolean;
    lastSeenLogId: number;
}